
import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface DoctorReviewsTabProps {
  rating: number;
  reviewsCount: number;
}

const DoctorReviewsTab: React.FC<DoctorReviewsTabProps> = ({ rating, reviewsCount }) => {
  // Sample reviews - in a real app, these would come from an API
  const sampleReviews = [
    {
      id: 1,
      name: "Sarah Johnson",
      rating: 5,
      date: "2 months ago",
      comment: "Dr. Wilson is amazing! He took the time to explain everything and made me feel comfortable throughout my dental procedure."
    },
    {
      id: 2,
      name: "Michael Thompson",
      rating: 4,
      date: "3 months ago",
      comment: "Very professional and knowledgeable. The only reason I'm not giving 5 stars is because I had to wait a bit longer than expected for my appointment."
    },
    {
      id: 3,
      name: "Jessica Barnes",
      rating: 5,
      date: "4 months ago",
      comment: "Dr. Wilson transformed my smile! I couldn't be happier with the results. His attention to detail is remarkable."
    }
  ];

  return (
    <div className="space-y-4">
      {/* Rating Summary */}
      <div className="flex items-center justify-between p-4 bg-secondary/30 rounded-lg">
        <div className="flex items-center gap-2">
          <div className="text-2xl font-bold">{rating}</div>
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`h-5 w-5 ${
                  i < Math.floor(rating)
                    ? "text-yellow-400 fill-yellow-400"
                    : i < rating
                    ? "text-yellow-400 fill-yellow-400 opacity-50"
                    : "text-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
        <div className="text-muted-foreground">
          Based on {reviewsCount} reviews
        </div>
      </div>
      
      {/* Reviews List */}
      {sampleReviews.map(review => (
        <Card key={review.id}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{review.name}</p>
                <div className="flex my-1">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`h-4 w-4 ${
                        i < review.rating
                          ? "text-yellow-400 fill-yellow-400"
                          : "text-gray-300"
                      }`}
                    />
                  ))}
                </div>
              </div>
              <span className="text-xs text-muted-foreground">{review.date}</span>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">{review.comment}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DoctorReviewsTab;
